<template>
    <div class="row px-5">
        <div class="col-12 col-md-11 col-lg-11">
            <Template :recurrentExpense="recurrentExpense"/>
        </div>
        <div class="col-12 col-md-1 col-lg-1 d-flex flex-column align-items-center pt-8">
            <div class="card w-100">
                <div class="d-flex flex-wrap justify-content-center">
                    <Button btn-class="me-3 mb-5 btn-sm" @click="printButton" :title="$t('crm.invoices.print')" icon-class="fas fa-print" type="new"></Button>
                </div>
            </div>
        </div>
    </div>

</template>

<script setup>
import Button from "@/components/Button";
import Template from "./Template"
import {useStore} from "vuex";
import {useLocales} from "@/composables/locales";

const store = useStore()
const { locale } = useLocales()

const props = defineProps({
  recurrentExpense: { type: Object, required: true },
  currency: String
})

function printButton() {
    let prtHtml1 = document.getElementById('expense-container');
    let WinPrint = window.open('', 'Print-Window', 'left=0,top=0,width=800,height=900,toolbar=1,scrollbars=0,status=0');

    WinPrint.document.write(`<!DOCTYPE html>
        <html>
        <head>
            <style>
                @page {
                    size: A4;
                    margin: 0;
                }
                body, html {
                    margin: 0;
                    font-family: 'Poppins', Helvetica, sans-serif;
                    font-size: 13px;
                    color: #181c32;
                    -webkit-font-smoothing: antialiased;
                    -moz-osx-font-smoothing: grayscale;
                    width: 100%;
                    height: 100%;
                    padding: 0;
                    box-sizing: border-box;
                    background-color: #F2F3F4;
                }
                .content {
                    padding: 30px;
                    box-sizing: border-box;
                    min-height: calc(100% - 150px); /* Adjust for footer height */
                }
                .otherStyle {
                    color: #0072CE;
                    font-weight: 500;
                }
                .img_class {
                    border: 2px dashed #0072CE;
                }
                .flex-item {
                    flex: 1;
                }
                .spacer {
                    min-width: 20px;
                }
                .d-flex {
                    display: flex;
                    justify-content: space-between;
                }
                .text-left {
                    text-align: left;
                }
                .text-right {
                    text-align: right;
                }
                .text-center {
                    text-align: center;
                }
                h5, h4 {
                    margin: 0;
                }
                .text-right img {
                    width: 100px;
                    height: 100px;
                    margin-bottom: 20px;
                }
                .table {
                    width: 100%;
                    border-collapse: collapse;
                    margin-bottom: 20px;
                    page-break-inside: auto; /* Allow table to break across pages */
                }
                .table th, .table td {
                    padding: 15px 9px;
                    text-align: center;
                }
                .table th {
                    background-color: #0072CE !important;
                    color: #fff !important;
                }
                .table td {
                    background-color: #fff !important;
                }
                .table tr {
                    page-break-inside: avoid; /* Avoid breaking rows across pages */
                    page-break-after: auto;
                }
                .positionLeft {
                    width: 50%;
                }
                .terms {
                    color: #F07817;
                }
                .footer {
                    position: absolute;
                    bottom: 0;
                    width: 100%;
                    background-color: #F2F3F4;
                    box-sizing: border-box;
                    padding: 0 30px 10px 30px;
                }
                .footer1 {
                    border-top: 1px solid #e0e0e0;
                    display: flex;
                    justify-content: space-between;
                    align-items: flex-start; /* Align items to the start */
                    margin-top: 10px;
                }
                .footer2 {
                    margin-bottom: 20px;
                }
                .footer div {
                    flex: 1;
                    text-align: left; /* Align text to the left */
                }
                .totals_items {
                    flex: 1;
                    width: 100%;
                    display: flex;
                }
                .total-item {
                    display: flex;
                    justify-content: space-between;
                    background-color: #fff;
                    width: 45% !important;
                    padding: 10px 15px !important;
                    margin-top: 5px;
                    margin-bottom: 10px;
                    color: rgb(0, 114, 206);
                }
                .label {
                    text-align: left;
                }
                .value {
                    text-align: right;
                    margin-top: -15px !important;
                }
                .specific {
                    background-color: rgb(0, 114, 206);
                    color: rgb(255, 255, 255);
                }
                .py-5 {
                    padding: 0.75rem 1rem !important;
                    margin-bottom: 5px;
                }
            </style>
        </head>
        <body>
            <div class="content">
                ${prtHtml1.innerHTML}
            </div>
        </body>
        </html>`);

    WinPrint.document.close();
    WinPrint.focus();

    setTimeout(() => {
        WinPrint.print();
        WinPrint.close();
    }, 1000);
}

</script>

<style scoped>
   .table th {
     background-color: #0072CE;
     color: #ffffff;
   }
   .table tr {
     background-color: #fff;
     margin-bottom: 5px;
     border-bottom: 3px solid #F2F3F4;
   }
</style>
